<template>
  <div>
    <LoadActivitiesModal />
    <TruckAuditLogModal />
    <DeleteTruckModal />
    <TruckNotEmptyModal />
    <TruckOrderViewModal />
    <AddTruckModal />
    <FinalizeTruckModal />
    <UnfinalizeTruckModal />
    <TruckMapViewModal />
    <OrderPreviewModal />
    <DriverManifestModal />
    <AddNotesModal />
  </div>
</template>
<script>
import LoadActivitiesModal from "@/components/widgets/Modals/LoadActivitiesModal";
import TruckAuditLogModal from "@/components/widgets/Modals/TruckAuditLogModal";
import DeleteTruckModal from "@/components/widgets/Modals/DeleteTruckModal";
import TruckNotEmptyModal from "@/components/widgets/Modals/TruckNotEmptyModal";
import TruckOrderViewModal from "@/components/widgets/Modals/TruckOrderViewModal";
import AddTruckModal from "@/components/widgets/Modals/AddTruckModal";
import FinalizeTruckModal from "@/components/widgets/Modals/FinalizeTruckModal";
import UnfinalizeTruckModal from "@/components/widgets/Modals/UnfinalizeTruckModal";
import TruckMapViewModal from "@/components/widgets/Modals/TruckMapViewModal.vue"
import OrderPreviewModal from "@/components/widgets/Modals/OrderPreviewModal.vue"
import DriverManifestModal from "@/components/widgets/Modals/DriverManifestModal.vue"
import AddNotesModal from "@/components/widgets/Modals/AddNoteModal.vue"

export default {
  name: "TrucksActions",
  components: {
    LoadActivitiesModal,
    TruckAuditLogModal,
    DeleteTruckModal,
    TruckNotEmptyModal,
    TruckOrderViewModal,
    AddTruckModal,
    FinalizeTruckModal,
    UnfinalizeTruckModal,
    TruckMapViewModal,
    OrderPreviewModal, 
    DriverManifestModal,
    AddNotesModal
  }
};
</script>
